import { render, staticRenderFns } from "./WorkRecordItem.vue?vue&type=template&id=fed01322&scoped=true"
import script from "./WorkRecordItem.vue?vue&type=script&lang=js"
export * from "./WorkRecordItem.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordItem.vue?vue&type=style&index=0&id=fed01322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed01322",
  null
  
)

export default component.exports